<template>
  <div class="handle_bar">
    <new-search-box v-if="componentInfo && componentInfo.contentSearch" />
    <client-only>
      <!-- <template v-if="componentInfo && componentInfo.appDownload">
        <el-popover
          v-if="componentInfo.androidUrl || componentInfo.iosUrl"
          placement="bottom"
          trigger="hover"
          :width="165"
        >
          <template #reference>
            <el-button
              link
              class="handle_bar_item"
            >
              APP下载
            </el-button>
          </template>
          <template #default>
            <div class="app_download_box">

              <div
                v-if="componentInfo?.androidUrl"
                class="code"
              >
                <qrcode
                  :value="componentInfo.androidUrl"
                  :size="140"
                />
                <div class="code-text">
                  Android APP下载
                </div>
              </div>

            </div>
          </template>
        </el-popover>
        <span
          v-else
          class="handle_bar_item"
        >
          APP下载
        </span>
      </template> -->
    </client-only>
<!--    <user-avatar />-->
  </div>
</template>

<script setup>
const props = defineProps({
  componentInfo: {
    type: Object,
    default: function () {
      return {}
    }
  }
})
// const componentInfo = toRefs(props.componentInfo)
// console.log('componentInfo', componentInfo)
</script>

<style lang="scss" scoped>
.handle_bar {
  height: 30px;
}
.handle_bar_item {
  font-size: 14px;
  white-space: nowrap;
  color: white !important;
}

.app_download_box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .code {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:first-child {
      margin-right: 30px;
    }

    .code-text {
      text-align: center;
      margin-top: 6px;
    }
  }
}
</style>
